<template>
    <div class="user-module w-full">
        <div class="flex mt-8 w-full">
            <div class="flex w-4/5">
                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group form-checkbox mt-8 mb-5">
                        <input
                            tabindex="1"
                            @input="resetLeadUsers"
                            class
                            type="checkbox"
                            name="techUsers"
                            v-model="form.tech_users"
                            id="techUsers"
                        />
                        <label class="w-full" for="techUsers">Radni nalog tehničko osoblje</label>
                    </div>

                    <div class="form-group">
                        <label for="name">Naziv radnog naloga</label>
                        <input
                            tabindex="4"
                            id="name"
                            class="form-control"
                            :class="{ _error: validationErrors.name}"
                            type="text"
                            v-model="form.name"
                        />
                        <span
                            class="error-message"
                            v-if="validationErrors.name"
                            v-text="validationErrors.name[0]"
                        ></span>
                    </div>

                    <div class="form-group">
                        <label for="customer">Kupac</label>
                        <div class="flex flex-col w-full">
                            <div class="flex w-full items-center">
                                <v-select
                                    :tabindex="6"
                                    class="form-select"
                                    :class="{ _error: validationErrors['customer.'] || validationErrors.customer}"
                                    id="customer"
                                    v-model="form.customer"
                                    :options="customerList"
                                    label="name"
                                    :clearable="false"
                                ></v-select>
                            </div>
                            <span
                                class="error-message"
                                v-if="validationErrors.customer"
                                v-text="validationErrors.customer[0]"
                            ></span>
                        </div>
                    </div>
                </div>

                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group flex items-center mt-3">
                        <div class="box-switch">
                            <input
                                tabindex="2"
                                type="checkbox"
                                id="status"
                                name="status"
                                v-model="form.status"
                            />
                            <span class="switch-path"></span>
                            <label for="status" v-text="form.status ? 'Aktivan' : 'Neaktivan'"></label>
                        </div>
                        <span
                            class="error-message"
                            v-if="validationErrors.status"
                            v-text="validationErrors.status[0]"
                        ></span>
                    </div>

                    <div class="form-group">
                        <label for="code">Šifra</label>
                        <input
                            tabindex="5"
                            id="code"
                            class="form-control"
                            :class="{ _error: validationErrors.code}"
                            type="text"
                            v-model="form.code"
                        />
                        <span
                            class="error-message"
                            v-if="validationErrors.code"
                            v-text="validationErrors.code[0]"
                        ></span>
                    </div>
                    <div class="form-group">
                        <label for="description">Opis</label>
                        <input
                            tabindex="7"
                            id="description"
                            class="form-control"
                            :class="{ _error: validationErrors.description}"
                            type="text"
                            v-model="form.description"
                        />
                        <span
                            class="error-message"
                            v-if="validationErrors.description"
                            v-text="validationErrors.description[0]"
                        ></span>
                    </div>
                </div>
                <div class="flex flex-col px-6 w-1/3">
                    <div class="form-group">
                        <label for="lead">Voditelj</label>
                        <div
                            v-for="(user, index) in form.lead_users"
                            :key="'lead-users-' + index"
                            class="flex flex-col w-full"
                        >
                            <div class="flex w-full items-center">
                                <v-select
                                    :tabindex="3"
                                    class="form-select"
                                    :class="{ _error: validationErrors['lead_users.' + index] || validationErrors.lead_users}"
                                    id="lead"
                                    v-model="form.lead_users[index]"
                                    :options="leadList"
                                    label="full_name"
                                    @input="checkDuplicate($event, index)"
                                    :clearable="false"
                                ></v-select>
                                <button @click="removeLead(index)" class="pt-2">
                                    <img class="w-12 mx-4" src="/svg/delete.svg" alt="add" />
                                </button>
                            </div>
                            <span
                                class="error-message"
                                v-if="validationErrors['lead_users.' + index]"
                                v-text="validationErrors['lead_users.' + index][0]"
                            ></span>
                            <span
                                class="error-message"
                                v-if="validationErrors.lead_users"
                                v-text="validationErrors.lead_users[0]"
                            ></span>
                        </div>
                        <div class="flex w-full justify-end pt-2">
                            <button @click="addLead">
                                <img class="w-12" src="/svg/button_add.svg" alt="add" />
                            </button>
                        </div>
                        <span
                            class="error-message"
                            v-if="userExistsWarning"
                            v-text="userExistsWarning"
                        ></span>
                    </div>
                </div>
            </div>
            <div class="flex justify-start items-end w-1/5">
                <div class="flex flex-col">
                    <button class="btn primary" @click="submitForm()" :disabled="procesing">Spremi</button>
                </div>
            </div>
        </div>
        <div>
            <h2 class="w-full mr-4" v-if="redirectMessage" v-text="redirectMessage"></h2>
        </div>
        <response v-if="showResponse" :data="responseData"></response>
    </div>
</template>
<script>
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import Response from "./Response";

export default {
    components: {
        vSelect,
        Response,
    },

    props: {
        projectData: {
            type: Object,
            default: () => ({}),
        },
        nonTechUsers: {
            type: Array,
            default: () => [],
        },
        techUsers: {
            type: Array,
            default: () => [],
        },
        customerList: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            form: {
                tech_users: false,
                name: "",
                code: "",
                status: true,
                lead_users: [],
                customer: "",
                description: "",
            },
            validationErrors: {},
            redirectMessage: "",
            showResponse: false,
            responseData: {},
            procesing: false,
            userExistsWarning: "",
        };
    },

    computed: {
        leadList() {
            if (this.form.tech_users) {
                return this.techUsers;
            } else {
                return this.nonTechUsers;
            }
        },
    },

    created() {
        this.showLoader();
        if (!this.form.lead_users.length) {
            this.form.lead_users.push(" ");
        }

        // Set the inputs to values to given user data
        if (this.projectData.id) {
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    case "status":
                        this.form[key] = this.projectData.deleted_at == null;
                        break;
                    case "customer":
                        this.form[key] = this.customerList.find(
                            (customer) =>
                                customer.id == this.projectData.customer_id
                        );
                        break;
                    default:
                        this.form[key] = this.projectData[key];
                        break;
                }
            });
        }

        setTimeout(() => {
            this.hideLoader();
        }, 500);
    },

    methods: {
        // Checks if user is already picked
        checkDuplicate(fuser, findex) {
            let userExists = false;

            _.forEach(this.form.lead_users, (user, index) => {
                if (typeof user.id != "undefined" && index != findex) {
                    if (user.id == fuser.id) {
                        userExists = true;
                    }
                }
            });

            if (userExists) {
                this.userExistsWarning = "Korisnik je već dodan na listu.";
                this.form.lead_users[findex] = " ";
            } else {
                this.userExistsWarning = "";
            }
        },

        // Resets picked lead users
        resetLeadUsers() {
            this.form.lead_users = [" "];
        },

        // Remove selected Lead
        removeLead(index) {
            this.form.lead_users.splice(index, 1);
        },

        // Adds a Lead
        addLead() {
            this.form.lead_users.push(" ");
        },
        // Submit the form to create a new user
        submitForm() {
            this.procesing = true;

            this.showLoader();

            const lastPage = localStorage.getItem('projects_last_page');

            let formData = new FormData();
            let endpoint = "";

            // Append all form items
            _.forEach(this.form, (item, key) => {
                switch (key) {
                    case "lead_users":
                        _.forEach(item, (user, index) => {
                            if (typeof user.id !== "undefined") {
                                formData.append(
                                    "lead_users[" + index + "]",
                                    user.id
                                );
                            }
                        });
                        break;
                    case "customer":
                        if (typeof item.id != "undefined") {
                            formData.append("customer_id", item.id);
                        } else {
                            formData.append("customer_id", "");
                        }
                        break;
                    default:
                        formData.append(key, item);
                        break;
                }
            });

            // Conditionaly add method to form submit
            if (this.projectData.id) {
                formData.append("_method", "PATCH");
            }

            if (lastPage) {
                formData.append('page', lastPage);
            }

            // Sets the endpoint with data for store/update depending on create or update
            if (this.projectData.id) {
                let data = {
                    project: this.projectData.id,
                };
                console.log(data);
                endpoint = route("projects.update", data);
            } else {
                endpoint = route("projects.store");
            }

            // Send the formData to project controller store/update function depending on endpoint
            axios
                .post(endpoint, formData)
                .then((response) => {
                    if (response.status === 200) {
                        this.responseData = response.data.data;
                        this.showResponse = true;

                        setTimeout(() => {
                            this.hideLoader();

                            const lastPage = localStorage.getItem('projects_last_page');
                            localStorage.removeItem('projects_last_page');

                            let redirectUrl = route("projects.index");
                            if (lastPage) {
                                redirectUrl += `?page=${lastPage}`;
                            }

                            window.location.href = redirectUrl;
                        }, 2000);

                    }
                })
                .catch((error) => {
                    this.procesing = false;
                    if (typeof error.response !== "undefined")
                        this.validationErrors = error.response.data.errors;

                    console.error(error);

                    this.hideLoader();
                });
        },
    },
};
</script>
